export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/admin/auth/login",
    LOGOUT: "/admin/auth/logout",
    VERIFY: "/admin/auth/verify",
    REFRESH: "/admin/auth/refresh",
    REGISTER: "/admin/auth/register",
    FORGOT_PASSWORD: "/admin/auth/forgot-password",
    RESET_PASSWORD: "/admin/auth/reset-password",
  },

  // Users endpoints
  USERS: {
    GET_ALL: "/admin/users",
    GET_BY_ID: (id) => `/admin/users/${encodeURIComponent(id)}`,
    CREATE: "/admin/users",
    UPDATE: (id) => `/admin/users/${encodeURIComponent(id)}`,
    DELETE: (id) => `/admin/users/${encodeURIComponent(id)}`,
  },

  // User Profile endpoints
  USER_PROFILE: {
    GET: (uid) => `/admin/users/${encodeURIComponent(uid)}/profile`,
    UPDATE: (uid) => `/admin/users/${encodeURIComponent(uid)}/profile`,
    UPLOAD_AVATAR: (uid) =>
      `/admin/users/${encodeURIComponent(uid)}/profile/avatar`,
  },

  // Daily Usage endpoints
  DAILY_USAGE: {
    GET: (uid, date) =>
      `/admin/users/${encodeURIComponent(uid)}/daily-usage/${date}`,
    GET_BY_DATE: (uid, date) =>
      `/admin/users/${encodeURIComponent(uid)}/daily-usage/${date}`,
    CREATE: "/admin/user/daily-usage",
    UPDATE: (id) => `/admin/user/daily-usage/${encodeURIComponent(id)}`,
  },

  // Meals endpoints
  MEALS: {
    GET_ALL: "/admin/meals",
    GET_BY_ID: (id) => `/admin/meals/${encodeURIComponent(id)}`,
    GET_USER_MEALS: (uid, date) =>
      `/admin/users/${encodeURIComponent(uid)}/meals?date=${date}`,
    CREATE: "/admin/meals",
    UPDATE: (id) => `/admin/meals/${encodeURIComponent(id)}`,
    DELETE: (id) => `/admin/meals/${encodeURIComponent(id)}`,
  },

  // Subscriptions endpoints
  SUBSCRIPTIONS: {
    GET_ALL: "/admin/subscriptions",
    GET_USER_SUBSCRIPTION: (uid) =>
      `/admin/subscriptions/${encodeURIComponent(uid)}`,
    CREATE: "/admin/subscriptions",
    UPDATE: (id) => `/admin/subscriptions/${encodeURIComponent(id)}`,
    CANCEL: (id) => `/admin/subscriptions/${encodeURIComponent(id)}/cancel`,
  },

  // Meal & Recipe Counts endpoints
  MEAL_RECIPE_COUNTS: {
    GET: (uid, date) =>
      `/admin/users/${encodeURIComponent(
        uid
      )}/subscription-daily-usage/${date}`,
    UPDATE: "/admin/user/meal-recipe-counts",
  },

  // User Plan endpoints
  USER_PLAN: {
    GET: (uid) => `/admin/users/${encodeURIComponent(uid)}/user-plan`,
    UPDATE: "/admin/user/plan",
    UPGRADE: "/admin/user/plan/upgrade",
    DOWNGRADE: "/admin/user/plan/downgrade",
  },

  // Diet Preferences endpoints
  DIET_PREFERENCES: {
    GET: (uid) => `/admin/users/${encodeURIComponent(uid)}/diet-preferences`,
    UPDATE: "/admin/user/diet-preferences",
    GET_ALL_OPTIONS: "/admin/diet-preferences/options",
  },

  // Analytics endpoints
  ANALYTICS: {
    GET_OVERVIEW: (days = 30) => `/admin/analytics/overview?days=${days}`,
    GET_RECENT_ACTIVITY: (days = 7) =>
      `/admin/analytics/recent-activity?days=${days}`,
    GET_USER_STATS: "/admin/analytics/users",
    GET_REVENUE_STATS: "/admin/analytics/revenue",
    GET_SUBSCRIPTION_STATS: "/admin/analytics/subscriptions",
    GET_USAGE_STATS: "/admin/analytics/usage",
  },

  // Premium Access endpoints
  PREMIUM: {
    GRANT_PREMIUM: "/admin/premium/grant-premium",
    REVOKE_PREMIUM: "/admin/premium/revoke-premium",
  },

  // Workout Plans endpoints
  WORKOUT_PLANS: {
    GET_USER_PLANS: (uid) => `/admin/workout-plans/${encodeURIComponent(uid)}`,
  },
};
